import { render, staticRenderFns } from "./OwnersPage.vue?vue&type=template&id=30d69d9d&"
import script from "./OwnersPage.vue?vue&type=script&lang=js&"
export * from "./OwnersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports